import { CREATE_FRANCHISE_SUCCESS, CREATE_FRANCHISE_LOADING } from '../admin/actions/types'

const initialState = {
    isLoadingCreate: false,
    loading: false,
    inventory:[],
    data: {},
}
export const franqusieeReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_FRANCHISE_LOADING:
            return { ...state, isLoadingCreate: true }
        case CREATE_FRANCHISE_SUCCESS:
            return { ...state, isLoadingCreate: false, data: action.payload }
        case "SEE_INVENTORY":
                return {...state,inventory:action.payload} 
        default:
            return state;
    }
}